module.exports = __webpack_public_path__ + "static/media/performante.7b0c173e.png";